import axiosInstance from '@/utils/api.js'

var state = {
  customCharges: [],
  customChargesDownload: []
}

var getters = {
  CUSTOM_CHARGES: (state) => {
    return state.customCharges
  },
  CUSTOM_CHARGES_DOWNLOAD: (state) => {
    return state.customChargesDownload
  }
}

var mutations = {
  SET_CUSTOM_CHARGES: (state, payload) => {
    state.customCharges = payload
  },
  SET_CUSTOM_CHARGES_DOWNLOAD: (state, payload) => {
    state.customChargesDownload = payload
  }
}

var actions = {
  GET_CUSTOM_CHARGES: async (context, payload) => {
    let result = await axiosInstance.get('/reports/custom_services?start=' + payload.numDateStart +
    '&end=' + payload.numDateEnd +
    '&user_id=' + payload.userId +
    '&account_id=0' + '&limit=' + payload.limit +
    '&download=' + payload.download, {timeout: 45000})
    if (result.status === 200) {
      context.commit('SET_CUSTOM_CHARGES', result.data)
    }
  },
  GET_CUSTOM_CHARGES_DOWNLOAD: async (context, payload) => {
    let result = await axiosInstance.get('/reports/custom_services?start=' + payload.numDateStart +
      '&end=' + payload.numDateEnd +
      '&user_id=' + payload.userId +
      '&account_id=0' + '&limit=' + payload.limit +
      '&download=' + payload.download, {timeout: 45000})
    if (result.status === 200) {
      context.commit('SET_CUSTOM_CHARGES_DOWNLOAD', result.data)
    }
  },
  CLEAR_CUSTOM_CHARGES: (context) => {
    context.commit('SET_CUSTOM_CHARGES', [])
    context.commit('SET_CUSTOM_CHARGES_DOWNLOAD', [])
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/reports/customChargesReport.js